import app from '@/app';

/* @ngInject */
function Works($resource) {
	return $resource(
		'api/workss/:id',
		{ id: '@id' },
		{
			query: { method: 'GET' },
			purge: { method: 'DELETE' }
		}
	);
}

app.factory('Works', Works);
